"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;

var _styles = require("@mui/styles");

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    arrow: {
      overflow: 'visible',
      marginTop: 10,
      '&:before': {
        content: "\"\"",
        width: 20,
        height: 20,
        background: 'inherit',
        position: 'absolute',
        right: 20,
        top: -10,
        border: '1px solid #e6e6e6',
        borderBottom: 'none',
        borderRight: 'none',
        transform: 'rotate(45deg)'
      }
    },
    popoverRoot: {
      overflow: 'auto'
    }
  };
});
exports.useStyles = useStyles;